export const SECTION_IDS = {
  ABOUT_US: "about-us",
  ADVANTAGES: "advantages",
  SERVICE_PACKAGES: "service-packages",
  SERVICES: "services",
  TEAM: "team",
  CONTACT_US: "contact-us",
} as const;

export const SECTION_IDS_ARRAY = Object.values(SECTION_IDS);
